import { createSelector } from 'reselect';

/* eslint-disable-next-line import/prefer-default-export */
export const getErrors = createSelector(
  [state => state.errors],
  errors => errors,
);
